import { Skeleton } from "@mui/material";
import classNames from "classnames";
import styles from "./style.module.scss";

interface SegmentedPillsSkeletonProps {
  count?: number;
  shape?: "pill" | "square" | "box";
  width?: number;
  className?: string;
}

function SegmentedPillsSkeleton({
  count = 4,
  shape = "pill",
  width = 88,
  className,
}: SegmentedPillsSkeletonProps) {
  return (
    <div className={classNames(styles.group, styles[shape], className)}>
      {Array.from({ length: count }).map((_, index) => (
        <Skeleton
          key={index}
          variant="rounded"
          width={width}
          height={28}
          sx={{ borderRadius: shape === "pill" ? "999px" : "4px" }}
        />
      ))}
    </div>
  );
}

export default SegmentedPillsSkeleton;
